import script from "./QuotaTipModal.vue?vue&type=script&setup=true&lang=js"
export * from "./QuotaTipModal.vue?vue&type=script&setup=true&lang=js"

import "./QuotaTipModal.vue?vue&type=style&index=0&id=69cacb23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69cacb23"]])

export default __exports__